module.exports = __webpack_public_path__ + "img/feature_buy_zh.67a020d0.png";